@if (flagImage) {
<div class="image-container" [class.rounded-circle]="rounded" [class.rounded]="!rounded" [ngStyle]="dimensions">
  <img [src]="flagImage" [alt]="name" (error)="onImageError()" />
</div>
}